import React, { useContext } from 'react';
import { Alert, Grid } from '@mui/material';
import { MapContext } from '../MapContext';
import { getShapeCenter } from './GeofenceManager.helpers';
import BareMap from '../BareMap';
import LatLngDisplay from '../../controls/LatLngDisplay';
import AddressSearchBar from '../../controls/AddressSearchBar';
import GeofenceArtist from './GeofenceArtist';
import GeofenceDrawingToolbar from './GeofenceDrawingToolbar';
import useGeofenceEditing from '../useGeofenceEditing';
import useGeofenceDrawing from '../terra-draw/useGeofenceDrawing';

const GeofenceMap = ({ center, searchable, displayOnly = false, maxFences = 2, address }) => {
    const { fences: geofences, selectedIndex, setFences, error } = useContext(MapContext);

    const canEdit = geofences.length <= maxFences && !displayOnly;
    const canDraw = geofences.length < maxFences && !displayOnly;

    const addGeofence = (type, addedFence) => {
        const newGeofences = [...geofences];
        const newFence = {
            ...addedFence,
            type,
            site_type: 'primary',
            enabled: true,
        };
        newGeofences.push(newFence);
        setFences(newGeofences);
    };

    const { DrawingControls, handleShapeChange } = useGeofenceEditing({ canEdit });
    const { activeMode, selectMode, ready } = useGeofenceDrawing({ addGeofence });

    const handleChange = (shapeType, index) => {
        const newGeofences = [...geofences];
        const newGeofenceAttributres = handleShapeChange(shapeType, index);
        if (!newGeofenceAttributres) return;
        newGeofences[index] = { ...newGeofences[index], ...newGeofenceAttributres };

        setFences(newGeofences);
    };

    let drawingHint = 'Use the toolbar to draw a circle or polygon geofence.';
    if (activeMode === 'polygon') {
        drawingHint = 'Click to drop each corner. Click the first point again (or double-click) to finish the polygon.';
    } else if (activeMode === 'circle') {
        drawingHint = 'Click to set the center, then click again to set the radius.';
    }

    if (!geofences) return null;

    return (
        <Grid container spacing={2}>
            {searchable && (
                <Grid item xs={12}>
                    <AddressSearchBar initialAddress={address} />
                </Grid>
            )}
            {canDraw && (
                <Grid item xs={12}>
                    <Alert severity="info">{drawingHint}</Alert>
                </Grid>
            )}
            {!!error && (
                <Grid item xs={12}>
                    <Alert severity="error">{error}</Alert>
                </Grid>
            )}
            {!displayOnly && (
                <Grid item xs={12}>
                    <GeofenceDrawingToolbar activeMode={activeMode} selectMode={selectMode} disabled={!canDraw || !ready} />
                </Grid>
            )}
            <Grid item xs={12}>
                <BareMap
                    center={center}
                    mapTypeId="satellite"
                    mapContainerStyle={{ height: '500px', width: '100%' }}
                    zoom={16}
                    // wrap
                >
                    <GeofenceArtist
                        handleChange={handleChange}
                        canEdit={canEdit}
                        // wrap
                    />
                </BareMap>
            </Grid>
            {!displayOnly && (
                <>
                    {DrawingControls}
                    <LatLngDisplay center={getShapeCenter(geofences[selectedIndex])} canEdit={canEdit} handleChange={handleChange} />
                </>
            )}
        </Grid>
    );
};

export default GeofenceMap;
